export enum EmploymentType{
    FullTime,
    PartTime,
    Internship,
    Temporary
}